<script setup lang="ts">
  import { IconArrowLeft, IconArrowRight } from '@ui-kit';
  import { PressScanProps } from './types';

  const { text, subText } = defineProps<PressScanProps>();
</script>

<template>
    <div class="press-scan">
      <div class="scan-block">
        <span class="scan-button" />
        <IconArrowLeft />
      </div>
      <div class="text-block">
        <span v-if="text" class="scan-text" v-html="text"></span>
        <span v-if="subText" class="scan-text" v-html="subText"></span>
      </div>
      <div class="scan-block">
        <IconArrowRight />
        <span class="scan-button" />
      </div>
    </div>
</template>

<style scoped>
  .press-scan {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .press-scan svg {
    stroke: #ffffff;
  }

  .press-scan .scan-block {
    display: flex;
    gap: 8px;
    align-items: center;
    animation-name: arrow;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .press-scan .text-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .press-scan .scan-right {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .press-scan .scan-button {
    height: 74px;
    width: 6px;
    border-radius: 10px;
    background-color: #ffffff;
  }

  .press-scan .scan-text {
    text-align: center;
    white-space: break-spaces;
    color: #ffffff;
  }
  .press-scan .scan-text:nth-child(2) {
    font-size: 14px;
    color: #b3b3b3;
  }

  @keyframes arrow {
    from {
      gap: 8px;
    }

    50% {
      gap: 4px
    }

    to {
      gap: 8px;
    }
  }
</style>
  